var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    ry: 6,
    fill: "#1d9bf0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 8.94v.4c0 4.07-3.1 8.76-8.76 8.76-1.74 0-3.36-.51-4.72-1.38.24.03.49.04.73.04 1.44 0 2.77-.49 3.82-1.32a3.056 3.056 0 0 1-2.87-2.14c.19.04.38.06.58.06.28 0 .55-.04.81-.11a3.074 3.074 0 0 1-2.47-3.02v-.04c.42.23.89.37 1.39.39A3.064 3.064 0 0 1 5.1 8.02c0-.56.15-1.09.42-1.55a8.77 8.77 0 0 0 6.34 3.22 3.076 3.076 0 0 1 3-3.78c.89 0 1.68.37 2.25.97.7-.14 1.36-.39 1.95-.75-.23.72-.72 1.32-1.35 1.7.61-.07 1.21-.23 1.77-.48-.41.62-.93 1.16-1.54 1.59h.02Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.59d4a53046b8751322b677ac22a7c951.svg";
export { ForwardRef as ReactComponent };